import UpdatesCard from "./UpdatesCard";
export default UpdatesCard;
